import type React from 'react';
import IconButton from '@mui/material/IconButton';
import { CustomWidthTooltip } from './MorphingInfo';
import { StyledInfoIcon } from './StyledInfoIcon';

export const SelectDeviceInfo: React.FC = () => {
  return (
    <CustomWidthTooltip
      arrow
      title={
        <span style={{ fontSize: '1.2em' }}>
          The devices visualized in the software have been constructed based on publicly available information to
          represent the nominal state of medical devices available on the market.
          <br />
          <br /> Materialise does not warrant the exact match of the devices visualized in the software with any
          particular medical device available in the market (see manual for device representation measurements). The
          selection of such medical device shall be the responsibility of the health care professional.
        </span>
      }
      placement="left"
    >
      <IconButton size="large">
        <StyledInfoIcon />
      </IconButton>
    </CustomWidthTooltip>
  );
};
